import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  MenuItem,
} from "@material-ui/core";

import {
  SelectValidator,
  ValidatorForm,
  TextValidator
} from "react-material-ui-form-validator";
import { MuiPickersUtilsProvider, KeyboardDatePicker } from "@material-ui/pickers";
import { postObservacion, postTrackingObservacionNoGuardada, putCerrarInternacion } from "../../../../actions/autorizaciones/Autorizaciones";
import DateFnsUtils from "@date-io/date-fns";
import esLocale from "date-fns/locale/es";
import moment from "moment";
import AlertDialogSlideCancelar from "../../UI/AlertaCancelar";
import AutoCompleteDiagnostico from "../../UI/AutoCompleteDiagnostico";
import { startAlerta } from "../../../../actions/ui/alertas";

export const ModalObservaciones = (props) => {
  const dispatch = useDispatch();

  const { tiposObservaciones = [], solicitudSeleccionada } = useSelector(
    (state) => state.autorizaciones
  );
  const [mostrarMsjDelete, setMostrarMsjDelete] = useState(false);

  const [idTipoObservacion, setIdTipoObservacion] = useState(
    !!props.observacion ? props.observacion.idCodTipoObs : null
  );
  const [diagnosticoEgreso, setDiagnosticoEgreso] = useState(
    props.diagnosticoEgreso ?? null
  );
  const [descripcion, setDescripcion] = useState(
    !!props.observacion ? props.observacion.descripcion : ""
  );
  const [fecha, setFecha] = useState(
    !!props.observacion ? props.observacion.fecha : moment()
  );
  const [error, setError] = useState(false);

  const onChangeTextAreaHandler = (e) => {
    const hayError = e?.target?.value?.length === 0;
    setError(hayError);
    /*if (!hayError)*/
    setDescripcion(e.target.value);
  };

  const onSubmitHandler = (e) => {
    if (!props.cierreInternacion) {
      e.preventDefault();

      let observacion = null;
      if (!props.observacion) {
        observacion = {
          fecha: fecha,
          idSolicitud: props.idSolicitud,
          idTipoObservacion,
          descripcion,
        };
      } else {
        observacion = {
          fecha: fecha,
          idObservacion: props.observacion?.idObservacion,
          descripcion,
        };
      }

      const method = !props.observacion ? "POST" : "PUT";

      dispatch(postObservacion(observacion, props.idSolicitud, method, props.close));
    } else {
      if (!diagnosticoEgreso?.idProblema) return dispatch(startAlerta("Seleccione un Diagnósito de Egreso", "error", "Error"))
      let data = {
        fechaEgreso: fecha,
        idSolicitud: props.idSolicitud,
        idTipoObservacion,
        descripcion,
        idDiagnosticoEgreso: diagnosticoEgreso?.idProblema ?? null
      }
      dispatch(putCerrarInternacion(data, props.close, props.onCloseModalAuditar, props.filtros));
    }
  };

  const handleDecision = (decicion) => {
    if (decicion === 'SI') {
      setMostrarMsjDelete(false);
      props.close();
      

      let observacion = null;
      if (!props.observacion) {
        observacion = {
          fecha: fecha,
          idSolicitud: props.idSolicitud,
          idTipoObservacion,
          descripcion,
        };
      } else {
        observacion = {
          fecha: fecha,
          idObservacion: props.observacion?.idObservacion,
          descripcion,
        };
      }

      const method = !props.observacion ? "POST" : "PUT";

      dispatch(postTrackingObservacionNoGuardada(observacion, props.idSolicitud, method));

    } else {
      setMostrarMsjDelete(false)
    }
  }


  const handleClose = () => {
    if (!props.disabled) {
      setMostrarMsjDelete(true);
    } else {
      props.close();
    }
  }

  return (
    <>
      {mostrarMsjDelete && <AlertDialogSlideCancelar
        open={alert}
        setOpen={() => { }}
        handleDecision={handleDecision}
        mensaje={'Si cierra esta ventana sin guardar, no se aplicaran los cambios ¿Está seguro que desea continuar?'}
      />}
      <Dialog fullWidth maxWidth="sm" open={props.open} onClose={/*props.close*/handleClose}>
        <DialogTitle>{props.titulo}</DialogTitle>
        <DialogContent>
          <ValidatorForm onSubmit={onSubmitHandler}>
            <Grid container spacing={2}>
              {
                props.cierreInternacion && (
                  <Grid item xs={12}>
                    <AutoCompleteDiagnostico
                      autoCompleteValue={diagnosticoEgreso}
                      label="Diagnóstico al Egreso"
                      onChangeHandler={(diagnostico) => setDiagnosticoEgreso(diagnostico)}
                    />
                  </Grid>
                )
              }
              <Grid item xs={10} sm={10} md={8} lg={6} style={{ paddingLeft: 16 }}>
                <MuiPickersUtilsProvider
                  locale={esLocale}
                  utils={DateFnsUtils}
                >
                  <KeyboardDatePicker
                    margin="normal"
                    id="dialogFechaInicio"
                    label="Fecha"
                    format="dd/MM/yyyy"
                    okLabel="Aceptar"
                    required={true}
                    disabled={props.disabled}
                    minDate={solicitudSeleccionada.fechaIngreso}
                    minDateMessage={`La fecha no puede ser anterior a la Fecha de Ingreso`}
                    maxDate={moment().add(1, 'days').format("YYYY-MM-DD")}
                    maxDateMessage={`La fecha no puede ser posterior a la fecha actual`}
                    clearLabel="Limpiar"
                    cancelLabel="Cancelar"
                    value={
                      moment(fecha).isValid()
                        ? moment(fecha)
                        : null
                    }
                    onChange={(date) => {
                      setFecha(date);
                    }}
                    KeyboardButtonProps={{
                      "aria-label": "change date",
                    }}
                  />
                </MuiPickersUtilsProvider>
              </Grid>
              <Grid item xs={10} sm={10} md={8} lg={6} style={{ alignSelf: 'center', paddingLeft: 16 }}>
                <TextValidator
                  margin="normal"
                  fullWidth
                  label="Código"
                  name="codigoAlfa"
                  value={tiposObservaciones.find(s => s.idCodigo === idTipoObservacion)?.codigoAlfa}
                  autoComplete="off"
                  disabled={true}
                  InputLabelProps={{
                    shrink: idTipoObservacion ? true : false,
                  }}
                />
              </Grid>
              <Grid item xs={12} style={{ paddingLeft: 16 }}>
                {Array.isArray(tiposObservaciones) &&
                  tiposObservaciones?.length > 0 && (
                    <SelectValidator
                      fullWidth
                      label="Tipo de Observación"
                      name="idTipoObservacion"
                      value={idTipoObservacion}
                      disabled={/*!!props.observacion*/ false}
                      onChange={(e) => setIdTipoObservacion(e.target.value)}
                      validators={["required"]}
                      errorMessages={["Este campo es requerido"]}
                    >
                      {tiposObservaciones.map((tipoObs) => (
                        <MenuItem
                          key={tipoObs.idCodigo.toString()}
                          value={tipoObs.idCodigo}
                        >
                          {`${tipoObs.codigoAlfa} - ${tipoObs.observacion1}`}
                        </MenuItem>
                      ))}
                    </SelectValidator>
                  )}
              </Grid>
              <Grid item xs={12}>
                <TextValidator
                  fullWidth
                  variant="outlined"
                  multiline
                  rows={4}
                  label="Observación"
                  name="observacion"
                  value={descripcion}
                  disabled={
                    (props.desdeIngresoSolicitud &&
                      props.titulo !== "Agregar Observación") ||
                    props.disabled
                  }
                  onChange={onChangeTextAreaHandler}
                  validators={["required"]}
                  errorMessages={["Este campo es requerido"]}
                  error={error}
                  helperText={error && "Este campo es requerido"}
                />
              </Grid>
            </Grid>
            <div
              style={{
                margin: "1rem 0",
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-evenly",
              }}
            >
              <Button variant="contained" color="secondary" onClick={handleClose}>
                Cancelar
              </Button>
              <Button type="submit" variant="contained" disabled={props.disabled} color="primary">
                Guardar
              </Button>
            </div>
          </ValidatorForm>
        </DialogContent>
      </Dialog>
    </>
  );
};
